export default {
  triadList: "List of three-party groups",
  triadTrainingList: "List of three-party groups by ",
  promotion: "year group | year groups",
  youHaveAccess: "You currently have access to {number} {label} {active} {filtered}",
  filtered: "filtered results",
  female_active: "active | active",
  male_active: "active | active",
  female_archived: "archived | archived",
  male_archived: "archived | archived",
  loadingTriads: "Loading three-party groups...",
  homeTriad: "Three-party groups home",
  apprenticeShort: "A",
  tutorShort: "TP",
  apprenticeMasterShort: "MA",
  companyShort: "COMP",
  Apprentice: "Work-study apprentice",
  Tutor: "Tutor",
  "Apprentice master": "Mentor",
  "Apprentice master 2": "Mentor 2",
  "Company manager": "Company manager",
  Parent: "Parent",
  "Studea manager": "Digital Booklet supervisor",
  apprentices: "Work-study apprentices",
  tutors: "Tutors",
  apprenticeMasters: "Mentors",
  studeaManagers: "Digital booklet supervisors",
  map: "InseeCompany tutor",
  myContract: "My contract",
  myContacts: "My contacts",
  myContracts: "My contracts",
  myRegistrationSheet: "My pre-registration forms",
  help: "Online help",
  company: "InseeCompany",
  pedagogic_tutor: "Teaching tutor",
  company_tutor: "InseeCompany mentor",
  apprentice: "Work-study apprentice",
  tutor: "Tutor",
  apprenticeMaster: "Mentor",
  secondary_apprenticeMaster: "Secondary mentor",
  studeaManager: "Digital Booklet supervisor",
  legal_responsible: "Legal guardian",
  studea_ok: "Imported booklets",
  triad_not_ok: "Non-imported three-party",
  mission_goal: "Mission and objectives",
  contract: {
    rupture: {
      title: "Contract termination ",
      title_short: "Termination",
      waiting_approuval: "Contract termination pending validation",
      declaration_title: "Declaration of breach of contract",
      declaration_title_short: "Declaration of breach",
      add: "Declare a termination date",
      add_short: "Termination",
      modify: "Modify this breach of contract",
      modify_short: "Modify this breach",
      see: "See the detials for breach of contract",
      see_short: "Breach of contract",
      download_rupture_model: "Download the contract termination template",
      declare_at_by: ({ named }) => `Declared on ${named("date")} by ${named("user")}`,
      to_valid: "Termination to validate",
      delete: {
        title: "Cancel this contract termination’",
        confirm: "Are you sure you want to cancel this contract termination?",
        success: "Contract termination successfully cancelled!",
      },
    },
    dropped_out: {
      title: "this three-party group has dropped out of the training on",
      reason: "Reason :",
      comment: "Comment :",
      declaration_title: "Declare a training dropout",
      reasons: {
        1: "Reorientation to another course",
        2: "Abandonment of the training project",
        3: "Force majeure (illness, death, etc.)",
        4: "Others",
      },
      cancel: {
        title: "Cancel abandonment",
        confirm: "Are you sure you want to cancel this abandonment?",
        success: "Abandonment successfully cancelled!",
      },
      seeking_new_contract: "Looking for a new contract",
      signed_new_contract: "New contract signed",
      graduation: "Graduation",
    },
    more: "infos",
    empty_date: "No date specified for this contract",
    list: ({ named }) => `List of contracts for : ${named("apprentice")}`,
    livret_not_active: "The handbook has not been activated for this training course yet",
    livret_deactivate_confirm:
      "The handbook will become inaccessible to the apprentice and the other members of the three-party group until it is reactivated. Confirm the deactivation?",
    livret_deactivate_success: "The handbook was successfully deactivated",
    livret_activate_success: "The handbook was successfully activated",
  },
  sso: {
    click_here: "click here to log in to your account",
    other_profile: "For any other profile, please enter your username in the field below.",
  },
  secondary_user: {
    list: "List of secondary users",
    filtered: "filtered results",
  },
  change_year: "Access the yearbook:",
};
